import { render, staticRenderFns } from "./CertificationAssignmentHistory.vue?vue&type=template&id=c64002a6&scoped=true&"
import script from "./CertificationAssignmentHistory.vue?vue&type=script&lang=js&"
export * from "./CertificationAssignmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./CertificationAssignmentHistory.vue?vue&type=style&index=0&id=c64002a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64002a6",
  null
  
)

export default component.exports